import React from "react";
import { Users, UserX } from "lucide-react";

const Cell = ({ v, warn }) => <span className={`font-mono-tech text-sm ${v && warn ? "text-red-600 font-bold" : v ? "text-slate-800" : "text-slate-300"}`}>{v}</span>;

export default function TeamSummary({ data, onPickMember, selected }) {
  if (!data) return <div className="h-32 rounded-xl bg-slate-100 animate-pulse" />;
  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="team-summary">
      <div className="px-4 py-2.5 border-b border-slate-100 flex items-center justify-between">
        <div className="font-semibold text-sm flex items-center gap-2"><Users className="h-4 w-4 text-primary" />Mitarbeiter & offene Aufgaben</div>
        <button onClick={() => onPickMember("__none")} data-testid="team-unassigned-btn"
          className={`text-xs flex items-center gap-1 px-2 py-1 rounded-full border ${selected === "__none" ? "bg-primary text-white border-primary" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
          <UserX className="h-3.5 w-3.5" />Nicht zugewiesen: <b>{data.unassigned}</b>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="text-[11px] uppercase text-slate-400 tracking-wide">
            <th className="text-left px-4 py-2">Mitarbeiter</th><th>Offen</th><th>Überfällig</th><th>Heute</th><th>Hoch/Krit.</th><th>Rückm.</th><th>Ohne Bearb.</th>
          </tr></thead>
          <tbody>
            {data.members.map((m) => (
              <tr key={m.user_id} onClick={() => onPickMember(selected === m.user_id ? "" : m.user_id)} data-testid={`team-member-${m.user_id}`}
                className={`border-t border-slate-100 cursor-pointer text-center ${selected === m.user_id ? "bg-primary/5" : "hover:bg-slate-50"}`}>
                <td className="text-left px-4 py-2"><div className="font-medium text-slate-900">{m.name}</div><div className="text-[11px] text-slate-400">{m.role}</div></td>
                <td><Cell v={m.open} /></td><td><Cell v={m.overdue} warn /></td><td><Cell v={m.today} /></td>
                <td><Cell v={m.high} /></td><td><Cell v={m.feedback} /></td><td><Cell v={m.stale} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
